module.exports = __webpack_public_path__ + "static/img/4384_phase_function_Paper_PointsHejduk_Prediction.247f5a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4384_phase_function_Paper_PointsHejduk_Prediction.png
// module id = ggII
// module chunks = 0